import { ResponsiveTooltip } from "@krea/shared/design-system/ResponsiveTooltip";
import { cn } from "@krea/shared/utils";

import { getAttractivenessColor } from "./utils";

// Grade-label thresholds mirror getQualityTitle (2 / 5 / 9). For integer scores
// these coincide exactly with getAttractivenessColor's 1/4/8 breaks, so the
// label always agrees with the chip colour.
function getGradeLabel(score: number): string {
  if (score < 2) return "Low attractiveness";
  if (score < 5) return "Medium attractiveness";
  if (score < 9) return "High attractiveness";

  return "Very high attractiveness";
}

interface IAttractivenessScoreBadgeProps {
  score: number | null | undefined;
}

export const AttractivenessScoreBadge = ({
  score,
}: IAttractivenessScoreBadgeProps) => {
  // Guard null AND undefined without truthiness — a score of 0 is a valid grade.
  if (score == null) return null;

  const clampedScore = Math.min(Math.max(score, 0), 10);
  const label = getGradeLabel(clampedScore);

  return (
    <ResponsiveTooltip
      trigger={
        // Matches the circular score chip in OfferAttractivenessCard (reuses its
        // colour helper), sized down to sit inline in the offer-box header.
        // typography: score indicator chip — xs/semibold/white is its own
        // decorative contract, same family as OfferAttractivenessCard.
        <div
          role="img"
          aria-label={`${label}, score ${clampedScore} of 10`}
          className={cn(
            "flex size-7 shrink-0 items-center justify-center rounded-full border-2 border-white text-xs font-semibold text-white shadow-lg",
            getAttractivenessColor(clampedScore, "number"),
          )}
        >
          {clampedScore}
        </div>
      }
    >
      {label}
    </ResponsiveTooltip>
  );
};
